import Vue from 'vue';
import GeneralArticles from './GeneralArticles.vue';

window.initGeneralArticles = (el, options) => {
	new Vue({
		el,
		render: h => h(GeneralArticles, {
			props: options,
		}),
	});
};
